
/* injects from baggage-loader */

import React, { Component } from "react";
import { connect } from "react-redux";
import { SwarmDataMixin, getSwarmDataKeyForRequest } from "../../../mixins/swarmDataMixin";
import PropTypes from "prop-types";
import { createSelector } from "reselect";
import { getSwarmSubscriptionRequestSecondPopularSports } from "../../../helpers/terminalRequests/popularSports";
import Helpers from "../../../helpers/helperFunctions";
import Loader from "../loader";
import { Link } from "react-router";
import { t } from "../../../helpers/translator";
import Config from "../../../config/main";

class SecondPopularSports extends Component {
	render() {
		let { data } = this.props;
		return data ? (
			data.map(sport => (
				<Link key={sport.alias} to={`/prematch/${sport.alias}`}>
					<p className={sport.alias}>{t(sport.name)}</p>
				</Link>
			))
		) : (
			<Loader component="secondPopularSports" />
		);
	}
}

SecondPopularSports.propTypes = {
	data: PropTypes.array,
};

const mapStateToProps = _ => {
	let key = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestSecondPopularSports());
	return createSelector(
		[
			state =>
				state.swarmData.data[key] &&
				JSON.stringify(
					(() => {
						return Helpers.objectToArray(state.swarmData.data[key].sport)
							.sort((a, b) => a.order - b.order)
							.slice(1, Config.main.secondPopularGamesCount);
					})()
				),
		],
		data => {
			return {
				data: data && JSON.parse(data),
			};
		}
	);
};

export default connect(mapStateToProps)(
	SwarmDataMixin({
		Component: SecondPopularSports,
		ComponentWillMount: function () {
			this.swarmSubscriptionRequest = getSwarmSubscriptionRequestSecondPopularSports();
			this.swarmDataKey = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestSecondPopularSports());
			this.keepDataAfterUnsubscribe = true;
		},
	})
);
